(function() { window.GUID_3c424610_da6a_43db_add7_d9e3a75b9778 = { getGuid: function() { return "3c424610-da6a-43db-add7-d9e3a75b9778"; } }; })();
var CS;
(function (CS) {
    var Geolocation;
    (function (Geolocation) {
        class GeoAutoComplete {
            BindToInput(inputId, resultId) {
                var me = this;
                if (resultId != null) {
                    me.ResultContainer = $('#' + resultId);
                }
                var input = $('#' + inputId);
                var url = input.data('apiurl');
                // Check if the Google Maps API is already loaded
                if (typeof google !== 'undefined' && google.maps && google.maps.places) {
                    me.initializeAutocomplete(input);
                }
                else {
                    $.getScript(url, function () {
                        me.initializeAutocomplete(input);
                    });
                }
            }
            initializeAutocomplete(input) {
                var me = this;
                if (input.length > 0) {
                    me.Input = input;
                    var options = {
                    //types: ['address'] /*ne pas mettre, sinon, la recherche est trop limité*/ 
                    };
                    var autocomplete = new google.maps.places.Autocomplete(input[0], options);
                    var inputName = me.Input[0].name;
                    if (inputName != "") {
                        me.HiddenInput = $('<input name="' + inputName + '" type="hidden" />');
                        var geoLoc = me.Input.data('value');
                        if (geoLoc != "" && geoLoc != null) {
                            geoLoc.HtmlFormattedAddress = ""; /*Evite le japage sur un post parce que aime pas html injection*/
                        }
                        me.HiddenInput.val(JSON.stringify(geoLoc));
                        me.Input.attr("name", inputName + "InputText");
                        me.Input.parent().append(me.HiddenInput);
                    }
                    google.maps.event.addListener(autocomplete, 'place_changed', function () {
                        me.PlaceSelected(autocomplete.getPlace());
                    });
                    if (me.ResultContainer.length > 0) {
                        if (me.ResultContainer.html() != "") {
                            if (me.OnResultContainerLoaded != null) {
                                me.OnResultContainerLoaded();
                            }
                        }
                        me.ResultContainer.on('click', '.ClearButton', function () {
                            me.ResultContainer.empty();
                            me.HiddenInput.val(null);
                            if (me.OnResultContainerCleared != null) {
                                me.OnResultContainerCleared();
                            }
                        });
                    }
                    $('<button style="width:0;height:0;opacity:0;border:none;padding:0;" id="FakeLinkToAvoidBug" onclick="return false;"></button>').insertAfter(me.Input);
                }
            }
            PlaceSelected(place) {
                var me = this;
                me.Input.val("");
                if (typeof (place.geometry) == "undefined") {
                    return;
                }
                var googleLocation = {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng(),
                    name: place.name,
                    street_number: '',
                    postal_code: '',
                    postal_code_prefix: '',
                    route: '',
                    locality: '',
                    stateShort: '',
                    stateLong: '',
                    countryShort: '',
                    countryLong: '',
                    place_id: place.place_id,
                    url: place.url,
                    formatted_address: place.formatted_address
                };
                for (var i = 0; i < place.address_components.length; i++) {
                    var addressType = place.address_components[i].types[0];
                    if (addressType == "administrative_area_level_1") {
                        googleLocation['stateShort'] = place.address_components[i]['short_name'];
                        googleLocation['stateLong'] = place.address_components[i]['long_name'];
                    }
                    else if (addressType == "country") {
                        googleLocation['countryShort'] = place.address_components[i]['short_name'];
                        googleLocation['countryLong'] = place.address_components[i]['long_name'];
                    }
                    else if (typeof (googleLocation[addressType]) != undefined) {
                        googleLocation[addressType] = place.address_components[i]['long_name'];
                    }
                }
                var data = { googleLocation: JSON.stringify(googleLocation) };
                CompuSport.Ajax.Get(CSParameters.BaseUrl + "Global/GetGoogleLocationFormattedWithTimeZone/", data, function (response) {
                    if (me.ResultContainer.length > 0) {
                        me.ResultContainer.empty().append(response.HtmlFormattedAddress);
                        response.HtmlFormattedAddress = ""; /*Je vais ca, sinon, le post va japper avec le contenu HTML*/
                        me.HiddenInput.val(JSON.stringify(response));
                        if (me.OnPlaceSelected != null) {
                            me.OnPlaceSelected(place);
                        }
                    }
                });
            }
        }
        Geolocation.GeoAutoComplete = GeoAutoComplete;
        function GetLocation(callback) {
            if (navigator.geolocation) {
                navigator.geolocation.watchPosition(callback);
            }
            else {
                callback(null);
            }
        }
        Geolocation.GetLocation = GetLocation;
    })(Geolocation = CS.Geolocation || (CS.Geolocation = {}));
})(CS || (CS = {}));

//# sourceMappingURL=Geolocation.js.map
